// extracted by mini-css-extract-plugin
export default {"container":"cn-select_container__YHRnq","label":"cn-select_label__OYDjT","select":"cn-select_select__L2PTd"};